import React, { useState, useEffect } from "react";
import { handleUnauthorized } from '../../utils/apiHelper';
import { useNavigate, useParams } from 'react-router-dom';
import SuccessAlert from '../child/Alert/SuccessAlert';
import DengerAlert from '../child/Alert/DengerAlert';
import Loader from "../child/Loder";
import "../../quillCustomStyles.css"; // Make sure this CSS has your .ql-editor styles

const ViewCMSPageNew = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchUserData = async () => {
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/cmsById/${id}`;
      try {
        setLoading(true);
        const authToken = localStorage.getItem('authToken');

        const response = await fetch(API_ENDPOINT, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (response.status === 401) {
          handleUnauthorized(navigate);
          return;
        }

        const data = await response.json();
        setUserData(data.result);
      } catch (err) {
        setErrorMessage(err.message);
        setTimeout(() => setErrorMessage(""), 3000);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [id, navigate]);

  if (loading) return <Loader />;

  return (
    <div className="row gy-4">
      {successMessage && (
        <SuccessAlert message={successMessage} onClose={() => setSuccessMessage("")} />
      )}
      {errorMessage && (
        <DengerAlert message={errorMessage} onClose={() => setErrorMessage("")} />
      )}

      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            <b><p className="viewlabes">Title</p></b>
            <p className="viewdata">{userData?.title || 'N/A'}</p>

            <b><p className="viewlabes">Content</p></b>
            <div
              className="viewdata ql-editor" 
              dangerouslySetInnerHTML={{
                __html: userData?.content || 'N/A',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCMSPageNew;
